import React from 'react';
import { Container } from 'react-bootstrap';
import ExpiredIcon from 'assets/img/verification/expired.svg';

function LinkExpired() {
  return (
    <Container
      fluid
      className="vh-100 d-flex justify-content-center align-items-center flex-column"
    >
      <img src={ExpiredIcon} width={150} className="mb-2" />
      <p className="fs-4">Verification Link Unavailable</p>
      <p className="text-center mb-4">
        It appears you’ve already verified your email or your verification link
        has expired. <br /> If you’ve already confirmed your account, please
        proceed to sign in. <br /> Otherwise, request a new verification link.
      </p>
    </Container>
  );
}

export default LinkExpired;
